import { Navigate, Outlet, useLocation } from "react-router-dom";

import { canAccessRoute, getFallbackRoute } from "@/config/routes";
import { useRoles } from "@/hooks/useRoles";
import { useGlobalStore } from "@/stores/global";

/**
 * Route guard component that checks user roles against route permissions
 * Redirects to appropriate fallback route if user doesn't have access
 */
export const RoleRoute = () => {
  const { pathname } = useLocation();
  const { orgRole, workspaceRole } = useRoles();
  const activeWorkspaceId = useGlobalStore((state) => state.activeWorkspaceId);

  const hasAccess = canAccessRoute(pathname, orgRole, workspaceRole);

  if (!hasAccess) {
    const fallbackRoute = getFallbackRoute(
      orgRole,
      workspaceRole,
      activeWorkspaceId,
    );

    return <Navigate replace to={fallbackRoute} />;
  }

  return <Outlet />;
};
